/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Emptydescription2Inputs */

const en_notificationcenter_emptydescription2 = /** @type {(inputs: Notificationcenter_Emptydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New notifications will show up here.`)
};

/**
* | output |
* | --- |
* | "New notifications will show up here." |
*
* @param {Notificationcenter_Emptydescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_emptydescription2 = /** @type {((inputs?: Notificationcenter_Emptydescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Emptydescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_emptydescription2(inputs)
});
export { notificationcenter_emptydescription2 as "notificationCenter_emptyDescription" }